<script>
import {
  targetDoorSettingMethods,
  targetDoorSettingComputed,
} from '@state/targetDoorSettingHelpers.js'
import store from '@state/store'
import DialogEdit from './dialog-edit-target-door.vue'
export default {
  page: {
    title: 'Target Door Settings',
    meta: [{ name: 'description', content: 'The Target Door Settings page.' }],
  },
  components: { DialogEdit },
  data: () => ({
    header: [
      {
        text: 'number',
        width: '5%',
        value: 'index',
      },
      {
        text: 'reservationRelation',
        value: 'reservation_relation',
        width: '7%',
      },
      {
        text: 'deviceName',
        value: 'device_name',
        width: '15%',
      },
      {
        text: 'contractorName',
        value: 'contractor_name',
        width: '15%',
      },
      {
        text: 'reservationPage',
        value: 'page_booking',
        width: '20%',
      },
      {
        text: 'menu',
        value: 'menu',
        width: '15%',
      },
      {
        text: 'option',
        value: 'option',
        width: '15%',
      },
      {
        text: 'action',
        value: 'action',
        width: '8%',
      },
    ],
    actionButton: [
      {
        value: 'update',
        color: '#5198d7',
      },
    ],
    pagination: {
      page: 1,
      itemsPerPage: 1,
    },
    openDialog: false,
    userEdit: {},
    valueSearch: '',
    relationDisableString: '使用しない',
  }),
  computed: {
    ...targetDoorSettingComputed,
    computedDataTable() {
      return this.getListDeviceDetail?.map((item) => ({
        ...item,
        reservation_relation: this.getRelationStatus(item) ? '有効' : '無効',
        contractor_name: this.getRelationStatus(item)
          ? item.contractor_name
          : '',
      }))
    },
    computedSuccess() {
      return this.createDetailDeviceSuccess
    },
    computedPagination() {
      return this.getTotalPage
    },
    computedLoading() {
      return this.getIsLoading
    },
  },
  watch: {
    computedSuccess() {
      if (this.computedSuccess) {
        if (this.valueSearch) {
          const search = this.valueSearch
          this.getDeviceDetail({ device_name: search })
        } else {
          this.getDeviceDetail()
        }
      }
    },
  },
  created() {
    store.dispatch('snackbar/resetSnackbar')
    this.getDeviceDetail()
  },
  methods: {
    ...targetDoorSettingMethods,
    handleEditlUser(item, action, value) {
      this.userEdit = { ...item }
      this.userEdit.reservation_relation = item.reservation_relation === '有効'
      this.openDialog = true
    },

    closeDialog(v) {
      this.openDialog = v
    },

    handleChangePage(v) {
      this.getDeviceDetail({ page: v })
    },
    handleSubmitEditUser(v, user) {
      if (!user.reservation_relation) {
        user.contractor_name = this.relationDisableString
      }
      this.openDialog = false
      this.createDeviceTarget(user)
    },
    handleSearchUser() {
      const search = this.valueSearch.trim()
      this.getDeviceDetail({ device_name: search })
    },
    getRelationStatus(item) {
      return item.contractor_name !== this.relationDisableString
    },
  },
}
</script>

<template>
  <div id="idoors-target-door-settings">
    <BaseSubHeader>
      <v-form ref="form" class="d-flex" @submit.prevent="handleSearchUser">
        <v-text-field
          v-model="valueSearch"
          solo
          dense
          hide-details="auto"
          placeholder="Search"
          class="margin-input-search"
          maxlength="255"
        />
        <v-btn
          color="#5198d7"
          class="white--text custom_width custom_height mr-5"
          type="submit"
          >{{ $t('search') }}</v-btn
        >
      </v-form>
    </BaseSubHeader>
    <v-card class="mt-8 mb-10 pt-2 pb-6 pl-6 pr-6 rounded-lg" elevation="3">
      <BaseTableCustom
        :header="header"
        :datatable="computedDataTable"
        :pagination="computedPagination"
        :actionbutton="actionButton"
        :loading="computedLoading"
        @action="handleEditlUser"
        @changepage="handleChangePage"
      />
    </v-card>
    <DialogEdit
      :dialog="openDialog"
      :useredit="userEdit"
      @closeDialog="closeDialog"
      @handleSubmitEditUser="handleSubmitEditUser"
    />
  </div>
</template>

<style lang="scss">
#idoors-target-door-settings {
  .custom_width {
    width: 100px !important;
  }
  .custom_height {
    height: 38px !important;
  }
  .margin-input-search {
    margin-left: 55px !important;
  }
}
</style>
